import React from 'react';
import { SEOLayout } from '@layouts';
import dayjs from 'dayjs';
import * as DOMPurify from 'isomorphic-dompurify';
import { NextPage } from 'next';
import styles from './styles.module.scss';
import { ICompliancePageProps } from './CompliancePage.types';

const CompliancePage: NextPage<ICompliancePageProps> = ({
  title,
  description,
  lastUpdated,
  html,
}) => (
  <SEOLayout title={title} description={description}>
    <main className={styles.container}>
      <div className={styles.heroBanner}>
        <div className={styles.heroBannerContent}>
          <h1>{title}</h1>
          <span>Last Updated: {dayjs(lastUpdated).format('MMMM, YYYY')}</span>
        </div>
      </div>
      <div
        className={styles.htmlContent}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
      />
    </main>
  </SEOLayout>
);

export default CompliancePage;
